import { Box, Button, IconButton, TextField } from '@mui/material';
import { onLogin } from 'services/auth';
import { useAppContext } from '@containers';
import { useMediaQueries } from '@hooks';
import { useTranslation } from 'next-i18next';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';

const Login = ({
  onSignUp = () => {},
  onRecover = () => {},
  onClose = () => {},
}) => {
  const { setLogin } = useAppContext();
  const { isMobile } = useMediaQueries();
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation('common');
  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    // ServicesService;
    const { data, error } = await onLogin(form);
    if (data?.success) {
      const { data: res } = data;
      setLogin({
        ...res,
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (passwordRef.current && passwordRef.current?.value) {
        setForm((prev) => ({
          ...prev,
          password: passwordRef.current.value,
        }));
      }
    }, 700);
  }, []);
  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      id="form_login"
      sx={{
        '& .MuiInputBase-root, .MuiInputLabel-root': {
          color: '#000 !important',
        },
      }}
    >
      <TextField
        className="my-1"
        fullWidth
        label="Email"
        margin="dense"
        name="email"
        required
        size={'small'}
        type="email"
        value={form?.email}
        ref={emailRef}
        variant="standard"
        onChange={(res) => {
          setForm({
            ...form,
            email: res.target.value,
          });
        }}
      />

      <div className="flex flex-col items-end">
        <TextField
          className="my-1"
          fullWidth
          label="Password"
          margin="dense"
          name="password"
          required
          size={'small'}
          type={!showPassword ? 'password' : 'text'}
          value={form?.password}
          inputRef={passwordRef}
          variant="standard"
          onChange={(res) => {
            setForm({
              ...form,
              password: res.target.value,
            });
          }}
          InputProps={{
            endAdornment: (
              <>
                {form?.password?.length >= 1 && (
                  <IconButton
                    onClick={() => setShowPassword((show) => !show)}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff color="primary" />
                    ) : (
                      <Visibility color="primary" />
                    )}
                  </IconButton>
                )}
              </>
            ),
          }}
        />

        <Button
          dense
          className="text-primary-950"
          onClick={onRecover}
          variant="text"
        >
          <span className="normal-case font-normal">
            {t('login.forgot_password')}?
          </span>
        </Button>
      </div>
      <div className=" mt-4">
        <Button
          form={'form_login'}
          fullWidth
          onSubmit={onSubmit}
          type="submit"
          variant="contained"
          sx={{ backgroundColor: '#da5f06  !important' }}
        >
          {t('login.sign_in')}
        </Button>

        <Button
          color="primary"
          fullWidth
          variant="outlined"
          onClick={onSignUp}
          className="mt-3"
        >
          {t('login.sign_up')}
        </Button>
      </div>
    </Box>
  );
};

export default Login;
